import { IAppState } from '../../redux';

export function selectTermsDuration(state: IAppState): number {
  return state.termsDurations.durationInDays;
}
